import { cn } from "cn";
import type * as React from "react";
import { FieldWrapper } from "../field-wrapper";
import { useFieldContext } from "../form-context";

type DisplayFieldProps = {
  label?: React.ReactNode;
  optional?: boolean;
  description?: React.ReactNode;
  className?: string;
  render?: (value: string) => React.ReactNode;
};

export function DisplayField({
  label,
  optional,
  description,
  className,
  render,
}: DisplayFieldProps) {
  const field = useFieldContext<string>();

  return (
    <FieldWrapper
      label={label}
      optional={optional}
      description={description}
      className={className}
    >
      <div
        className={cn(
          /* sorted */
          "flex items-center",
          "h-10",
          "px-3 py-2",
          "border rounded-lg bg-bg-dark-low border-border-dark-low",
        )}
      >
        {render ? (
          render(field.state.value)
        ) : (
          <span className="text-text-dark">{field.state.value}</span>
        )}
      </div>
    </FieldWrapper>
  );
}
